module.exports = __webpack_public_path__ + "static/media/60.abd295c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/60.svg
// module id = 187
// module chunks = 0